import FinancialYear from "./FinancialYear";
import FinancialYearForm from "./FinancialYearForm";

const FinancialYearConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/financial-year',
            element: <FinancialYear />,
        },
        {
            path: '/add-financial-year',
            element: <FinancialYearForm />,
        },
        {
            path: '/edit-financial-year/:id',
            element: <FinancialYearForm />,
        },
    ],
}

export default FinancialYearConfig;
